module.exports = __webpack_public_path__ + "e10.no2.9aa34fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e10.no2.jpg
// module id = to3t
// module chunks = 0